import React from "react";

import Label from 'reactstrap/lib/Label';
import FormGroup from 'reactstrap/lib/FormGroup';
import Media from 'reactstrap/lib/Media';
import Input from 'reactstrap/lib/Input';

import pencilImg from '../../../../images/icons/pencil.svg';
import checkImg from '../../../../images/icons/check.png';
import cancelImg from '../../../../images/icons/close_old.png';
import closeImg from '../../../../images/icons/close.png';
import { TOURNAMENT_OPTION_IMAGES } from "../../../../constants/constants";

const FileUploadPrizeImage = React.memo(({
    preview,
    imageUrl,
    showCrop,
    hiddenFileInput,
    handleImageClick,
    handleImageChange,
    handleEditPhoto,
    uploadEventFile,
    imageType,
    loading,
    handlePreviewPhoto,
    handleImageUrl,
}) => {

    const handleEditPhotoCancel = () => {
        handleEditPhoto(showCrop);
        const previewImg = null;
        handlePreviewPhoto(previewImg, imageType);
    }

    const handleEditPhotoEdit = () => {
        handleEditPhoto(showCrop);
        uploadEventFile(imageType)
    }
console.log(imageUrl, preview, "selectUrl")
    return (
        <FormGroup className={`${imageType}-section`}>
            <Label>
                {/* {t('bannerImage')} */}
                {`${imageType.toUpperCase()} Image`}
            </Label>
            <div className="banner-image">
                {
                !preview && !imageUrl ? (
                    <Label className="banner-image-label">Please upload image.</Label>
                    // <Label className="banner-image-label">{t('uploadImage')}</Label>
                ) : (
                    <img className="event-banner-image" src={preview || imageUrl} alt="Preview" />
                )
                }
            </div>
            {!showCrop && (
                <div className="event-banner-edit">
                <Media onClick={() => handleEditPhoto(showCrop)} src={pencilImg} className="menu-player-edit-image" disabled={loading} />
                </div>
            )}
            {!showCrop && (
                <div className="event-banner-cancel">
                <Media onClick={handleImageUrl(imageType)} src={cancelImg} className="menu-player-edit-image" disabled={loading} />
                </div>
            )}
            {showCrop && (
                <div className="event-banner-edit">
                <Media onClick={handleEditPhotoEdit} src={checkImg} className="menu-player-edit-image" />
                </div>
            )}
            {showCrop && (
                <div className="event-banner-cancel">
                <Media onClick={handleEditPhotoCancel} src={cancelImg} className="menu-player-edit-image" />
                </div>
            )}
            {
                showCrop && (
                <div>
                    <div className="event-banner-button" onClick={handleImageClick}>
                    {/* {t('uploadImageButton')} */}
                        Upload a Image
                    </div>
                    <input
                        type="file"
                        ref={hiddenFileInput}
                        onChange={(e) => handleImageChange(e, imageType)}
                        style={{ display: 'none' }}
                        accept="image/*"
                    />
                </div>
                )
            }
            <Input
                type="text"
                name="imageUrl"
                id="imageUrl"
                placeholder=""
                hidden
                readOnly
                value={imageUrl}
            />
        </FormGroup>
    );
});

export default FileUploadPrizeImage;